<app-marine-insurance-card
  [cardTitle]="isShowCertificate ? 'MARINE_INSURANCE_BY_ANOVA' : 'MARINE_INSURANCE'"
  [isCanEdit]="isEditableQuote"
  (edit)="edit.emit()"
>
  <ng-container header-label>
    <div class="marine-insurance-quote-view-header-admin-warning" *ngIf="isPendingAdminApproval">
      <img class="marine-insurance-quote-view-header-admin-warning-icon" src="assets/icons/icon_warning_orange_sm.svg" />

      {{ "YOUR_REVISED_CERTIFICATE_WILL_BE_UPLOADED_SHORTLY" | translate }}
    </div>
  </ng-container>

  <ng-container body>
    <div class="marine-insurance-quote-view-warning" *ngIf="!marineInsurance?.certificate?.number">
      <div class="marine-insurance-quote-view-warning-icon">
        <img src="assets/icons/icon_warning_blue_sm.svg" />
      </div>

      <p class="marine-insurance-quote-view-warning-text">
        <span *ngIf="isAnovaDown">{{ "MARINE_INSURANCE_ANOVA_DOWN_MESSAGE" | translate }}</span>
        <span *ngIf="!isAnovaDown">{{ "MARINE_INSURANCE_QUOTE_FILL_HINT_3" | translate : { entity: entity || "" } }}</span>
      </p>
    </div>

    <div class="row">
      <div class="col-12 col-xl-6">
        <app-marine-insurance-quote-view-data
          [marineInsurance]="marineInsurance"
          [isShowUpdatedInsuredValue]="isShowUpdatedInsuredValue"
          [isShowUpdatedDate]="isShowUpdatedDate"
        ></app-marine-insurance-quote-view-data>
      </div>

      <div class="col-12 col-xl-6 d-xl-flex justify-content-xl-end pt-3 pt-xl-0" *ngIf="!!latestCertificateDocument">
        <document-upload-desktop
          [attachmentName]="'DOWNLOAD_POLICY_CERTIFICATE'"
          [isShowOptionalTag]="false"
          [isStripeLayout]="true"
          [isStretched]="true"
          [uploadedDocument]="latestCertificateDocument"
        ></document-upload-desktop>
      </div>
    </div>

    <div class="row" *ngIf="isShowCertificate">
      <div class="col-12">
        <div class="marine-insurance-quote-view-terms-link" (click)="showTerms()">
          {{ "LEARN_MORE_TERMS_OF_COVERAGE" | translate }}

          <img class="ml-2" src="/assets/icons/icon_chevron_down_gray.svg" />
        </div>
      </div>
    </div>

    <div class="marine-insurance-quote-view-footer" *ngIf="isShowTerms">
      <div class="row">
        <div class="col-12">
          <div class="marine-insurance-quote-view-footer-header">
            <h5 class="marine-insurance-quote-view-footer-header-text">{{ "COVERAGE_DETAILS" | translate }}</h5>

            <span class="marine-insurance-quote-view-footer-header-close" (click)="hideTerms()">
              <img class="mr-1" src="assets/icons/icon_close_gray_sm.svg" />
              <span>{{ "BUTTON.CLOSE" | translate }}</span>
            </span>
          </div>

          <app-marine-insurance-terms-data></app-marine-insurance-terms-data>
        </div>
      </div>
    </div>
  </ng-container>
</app-marine-insurance-card>
